// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! * [Scalable Text in CSS with Maximum and Minimum Sizes](https://github.com/kevinmack18/SCALABLE-TEXT-IN-CSS) */.visualization-years{width:100%;display:flex;flex-wrap:wrap}.visualization-years>div{margin-top:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
